// AddToCartButton/vtex.tsx

import { useCart } from "~/hooks/useCart";
import Button, { Props as BtnProps } from "./common";

export interface Props extends Omit<BtnProps, "onAddItem" | "platform"> {
  seller: string;
  skuId?: string;
}

function AddToCartButtonVTEX(props: Props) {
  const { addItems } = useCart();

  const onAddItem = () =>
    addItems({
      orderItems: [
        {
          id: props.skuId || props.product.productID,
          seller: props.seller,
          quantity: 1,
        },
      ],
    });

  return (
    <Button
      onAddItem={onAddItem}
      {...props}
      aria-label="Adicionar ao carrinho"
    />
  );
}

export default AddToCartButtonVTEX;
